export enum FeedbackThumb {
  UP = 'up',
  DOWN = 'down',
}

export type MessageFeedbackSubmission = {
  thumb: FeedbackThumb
  thumbText: string
  thumbReasons: string[]
}
